import { MenuNode, MenuVisibilityMap, RenderMenuNode } from './menu.types';

export function sortByPosition<T extends { position?: number }>(
  a: T,
  b: T
): number {
  const pa = a.position ?? 0;
  const pb = b.position ?? 0;
  return pa - pb;
}

export function applyVisibility(
  tree: MenuNode[],
  map: MenuVisibilityMap
): RenderMenuNode[] {
  const walk = (nodes: MenuNode[]): RenderMenuNode[] => {
    return nodes
      .map<RenderMenuNode | null>((n) => {
        const v = map[n.key];
        const alwaysVisible = n.action === 'logout';
        const selected = v?.selected === true;
        const disabled = alwaysVisible ? false : v?.disabled === true;

        const visibleChildren = n.children ? walk(n.children) : undefined;
        const hasVisibleChildren = !!visibleChildren?.length;

        const includeSelf = alwaysVisible || selected || hasVisibleChildren;
        if (!includeSelf) return null;

        const node: RenderMenuNode = {
          ...n,
          children: visibleChildren,
          disabled,
        };

        if (
          !alwaysVisible &&
          !node.route &&
          (!node.children || node.children.length === 0)
        ) {
          return null;
        }

        return node;
      })
      .filter((n): n is RenderMenuNode => !!n)
      .sort(sortByPosition);
  };

  return walk(tree);
}

export function flatten(nodes: RenderMenuNode[]): RenderMenuNode[] {
  const out: RenderMenuNode[] = [];
  const walk = (arr: RenderMenuNode[]) => {
    for (const n of arr) {
      out.push(n);
      if (n.children?.length) walk(n.children);
    }
  };
  walk(nodes);
  return out;
}

export function firstNavigable(
  nodes: RenderMenuNode[]
): RenderMenuNode | undefined {
  // 1. Flatten creates a list: [Parent, Child, Child, Parent2...]
  // 2. Filter removes items without routes
  const arr = flatten(nodes).filter((n) => !!n.route && !n.disabled);
  return arr[0];
}
